import { Crm5Activity } from "@/components/crm-demos/crm-5-activity"
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_crm-demos/crm-5")({
  component: Crm5Page,
  head: () => ({ meta: [{ title: "CRM 5 · Activity Timeline" }] }),
});

function Crm5Page() {
  return <Crm5Activity />
}
